// Google OAuth client ID for this environment, supplied by the server at page
// load rather than compiled into the bundle.
//
// This used to be a hostname map holding every environment's client ID, so a
// production bundle also carried the beta one. Node injects only this
// environment's value into index.html as `window.__APP_CONFIG__` (see
// 9696-node/server.js), read from secrets.yaml.
//
// The client ID is not secret — Google requires the browser to send it — but
// there is no reason to ship every environment's ID in every build.
export const googleAuthClientID = () => {
  const clientId =
    (typeof window !== 'undefined' && window.__APP_CONFIG__ && window.__APP_CONFIG__.googleClientId) || '';

  if (!clientId) {
    console.error(
      'Google client ID missing from window.__APP_CONFIG__ — sign-in will not work. ' +
        'Check google_auth.GOOGLE_CLIENT_ID in secrets.yaml on this server.'
    );
  }

  return [clientId, window.location.origin];
};
